import { repositories } from '../api/createRepositories';

const conversationsRepository = repositories.conversations;

export const conversationService = {
  
  getConversationDetails: async (conversationId) => {
    return await conversationsRepository.getConversationById(conversationId);
  },

  getConversationAudio: async (conversationId) => {
    return await conversationsRepository.getConversationAudio(conversationId);
  },


  getConversations: async (options = {}) => {
    const conversations = await conversationsRepository.getConversations(options);
    return {
      conversations: conversations,
      total: conversations.length,
      hasMore: false,
    };
  },

  deleteConversation: async (conversationId) => {
    return await conversationsRepository.deleteConversation(conversationId);
  },

  getConversationToken: async (agentId) => {
    return await conversationsRepository.getConversationToken(agentId);
  },

  getSignedUrl: async (agentId) => {
    return await conversationsRepository.getSignedUrl(agentId);
  }
};

export default conversationService;
